import React from "react";
import {
    IconButton,
    Button,
    Dialog,
    Divider,
    DialogContent,
    DialogActions
} from "@mui/material/";
import MuiDialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import withStyles from "@mui/styles/withStyles";
import { strings } from "../../../../common/i18n";
import styles from "./styles";

const DialogTitle = withStyles(styles)((props) => {
    const { onClose, titleText } = props;
    return (
        <MuiDialogTitle id="auditor-name-dialog-title">
            <div>{titleText}</div>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    sx={styles.closeButton}
                    onClick={onClose}
                    size="large"
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const CustomDialog = ({
    isModalShown,
    onSave,
    onClose,
    disabledSave,
    children
}) => {
    return (
        <Dialog open={isModalShown} fullWidth maxWidth={"sm"} onClose={onClose}>
            <DialogTitle
                onClose={onClose}
                titleText={strings(
                    "messages.editAuditName"
                )} /** On creating a columns */
            />
            <Divider />
            <DialogContent>{children}</DialogContent>
            <DialogActions sx={styles.dialogActions}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onSave}
                    sx={styles.dialogSaveBtn}
                    disabled={disabledSave}
                >
                    {strings("save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CustomDialog;
